/* eslint-disable no-new */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import store from './store';

Vue.config.productionTip = false

// Embedded Items

import loadDataMixin from './mixins/loadData';
import loadResultsMixin from './mixins/loadResults';
import loadCalledSeatsMixin from './mixins/loadCalledSeats';
import AllResultsTable from './components/AllResultsTable.vue';
import KeySeats from './components/KeySeats.vue';
import MapGroup from './components/MapGroup.vue';
import CalledSeats from './components/CalledSeats.vue';


Array.prototype.forEach.call(document.querySelectorAll('.election-allseats[embed]'),
    (el) => new Vue({
        mixins: [loadResultsMixin],
        el: el,
        data: {
            title: el.getAttribute('title') || 'Results from all seats',
            year: parseInt(el.getAttribute('year'), 10) || 2015
        },
        store,
        template: '<AllResultsTable :embed="true" :title="title" :currentYear="year" />',
        components: { AllResultsTable }
    })
);

Array.prototype.forEach.call(document.querySelectorAll('.election-map[embed]'),
    (el) => new Vue({
        mixins: [loadDataMixin],
        el: el,
        data: {
            title: el.getAttribute('title') || 'Election Results Map',
            year: parseInt(el.getAttribute('year'), 10) || 2015,
            insetRegion: el.getAttribute('inset')
        },
        store,
        template: '<MapGroup :embed="true" :title="title" :currentYear="year" :insetRegion="insetRegion" />',
        components: { MapGroup }
    })
);


Array.prototype.forEach.call(document.querySelectorAll('.election-keyseats[embed]'),
    (el) => new Vue({
        mixins: [loadResultsMixin],
        el,
        data: {
            keySeats: JSON.parse(`[${el.getAttribute('seats')}]`),
            title: el.getAttribute('title') || 'Results from key seats',
            year: parseInt(el.getAttribute('year'), 10) || 2015
        },
        store,
        template: '<KeySeats :embed="true" :keySeats="keySeats" :title="title" :currentYear="year" />',
        components: { KeySeats },
    })
);

Array.prototype.forEach.call(document.querySelectorAll('.election-calledseats[embed], .election-calledseats.embed'),
    (el) => new Vue({
        mixins: [loadCalledSeatsMixin],
        el: el,
        data: {
            title: el.getAttribute('title') || 'QLD Election 2017 Called Seats'
        },
        store,
        template: '<CalledSeats :embed="true" :title="title" :maxSeats="93" :realisticMax="60" />',
        components: { CalledSeats }
    })
);



// WEBPACK FOOTER //
// ./src/embed.js